// globalActions.ts
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import { createAction } from '@reduxjs/toolkit'

export const LOGOUT = 'session/logout'
export const COMPANY_CHANGE = 'company/CompanyChange'

/**
 * Action to force logout the user without going through CMC
 * @remarks Resets the state to initialState.
 */
export const logoutUser = createAction(LOGOUT)

/**
 * Action to clear state data when the company changes
 * @remarks Resets the state to initialState.
 */
export const companyChange = createAction(COMPANY_CHANGE)
